import * as React from 'react';
import clx from 'classnames';
import { Button, Typography } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { useCurrentUser } from 'client/components/auth/AuthModule';
import { UserLogic } from 'common/schema/UserLogic';

export interface ProcedureSubmitButtonProps extends ButtonProps {}

/**
 * Pulsante per l'invio (inoltro) dell'istanza
 */
export function ProcedureSubmitButton(props: ProcedureSubmitButtonProps) {
  const { ...buttonProps } = props;
  const user = useCurrentUser();

  const isNationalityAllowed = UserLogic.nationalityAllowsSending(user, true);

  return (
    <Button
      block
      size="large"
      type="primary"
      {...buttonProps}
      disabled={!isNationalityAllowed}
    >
      Inoltra Istanza
    </Button>
  );
}
